import { render, staticRenderFns } from "./AccessList.vue?vue&type=template&id=5d922919&scoped=true"
import script from "./AccessList.vue?vue&type=script&lang=js"
export * from "./AccessList.vue?vue&type=script&lang=js"
import style0 from "./AccessList.vue?vue&type=style&index=0&id=5d922919&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d922919",
  null
  
)

export default component.exports